import {ReactComponent as Netflix} from "./img/Netflix-img.svg";
import {ReactComponent as HBO} from "./img/HBO-img.svg";
import {ReactComponent as AppleTV} from "./img/AppleTV-img.svg";
import {ReactComponent as Prime} from "./img/Prime-img.svg";
import {ReactComponent as YouTube} from "./img/YouTube-img.svg";
import {ReactComponent as Disney} from "./img/Disney-img.svg";
import {ReactComponent as Amazon} from "./img/Amazon-img.svg";
import {ReactComponent as RakutenTV} from "./img/RakutenTV.svg";
import {ReactComponent as VUDU} from "./img/VUDU-img.svg";

import texts from "../../assets/ContextProvider/textsLocalized.json";
import styles from "./watch-movie-popup.module.css";

const WatchMoviePopup = ({linksData, isVisible, handleVisibility}) => {
  const existsLocalPlatforms = ['Netflix', 'HBO', 'AppleTV', 'Amazon', 'YouTube', 'Disney+', 'Prime Video', 'AppleTV+', 'Rakuten TV', 'VUDU'];

  const renderIcon = (platform) => {
    switch (platform) {
      case existsLocalPlatforms[0]:
        return <Netflix/>;
      case existsLocalPlatforms[1]:
        return <HBO/>;
      case existsLocalPlatforms[2]:
        return <AppleTV/>;
      case existsLocalPlatforms[3]:
        return <Amazon/>;
      case existsLocalPlatforms[4]:
        return <YouTube/>;
      case existsLocalPlatforms[5]:
        return <Disney/>;
      case existsLocalPlatforms[6]:
        return <Prime/>;
      case existsLocalPlatforms[7]:
        return <AppleTV/>;
      case existsLocalPlatforms[8]:
        return <RakutenTV/>;
      case existsLocalPlatforms[9]:
        return <VUDU/>;
      default:
        return null;
    }
  };


  // const tempLinksData = [
  //   {url: "https://www.netflix.com/title/81774713", platform: "Netflix"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Netflix"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Amazon"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Hamster"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Amazon"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "HBO"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "AppleTV"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "AppleTV"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Racoon"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Prime"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Amazon"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Disney"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Disney"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Amazon"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Amazon"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Prime"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "Amazon"},
  //   {url: "https://www.netflix.com/title/81774713", platform: "YouTube"},
  // ];


  const uniqueLinksData = linksData.reduce((acc, item) => {
    if (!acc.some(el => el.platform === item.platform)) {
      acc.push(item);
    }
    return acc;
  }, []).filter((elem) => existsLocalPlatforms.includes(elem.platform));


  return (
    <div className={styles['movie-watch-container']}>
      <div className={styles['movie-watch-container__message']}>
        <div className={styles['container-message-close']}
             onClick={() => handleVisibility(false)}></div>
        <p className={styles['container-message-title']}>
          {texts.movies['popup-link-title']}
        </p>
        <div className={`${styles['container-message-links']}
          ${isVisible ? styles['link-active'] : ''}
          ${uniqueLinksData.length <= 6 ? styles['non-scroll'] : ''}`}>
          {uniqueLinksData.map((item, index) => {
            return (
              <div className={styles['message-link']}
                   key={index}>
                <a href={item.url} target="_blank" rel="noreferrer">
                  {renderIcon(item.platform)}
                </a>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default WatchMoviePopup;